'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autosuggestion = require('../autosuggestion/autosuggestion.vue');

var _autosuggestion2 = _interopRequireDefault(_autosuggestion);

var _inputField = require('../input-field/input-field.vue');

var _inputField2 = _interopRequireDefault(_inputField);

var _datepicker = require('../datepicker/datepicker.vue');

var _datepicker2 = _interopRequireDefault(_datepicker);

var _dropDown = require('../drop-down/drop-down.vue');

var _dropDown2 = _interopRequireDefault(_dropDown);

var _button = require('../button/button.vue');

var _button2 = _interopRequireDefault(_button);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _imageshifter = require('../imageshifter/imageshifter.vue');

var _imageshifter2 = _interopRequireDefault(_imageshifter);

var _fontfaceobserver = require('fontfaceobserver/fontfaceobserver.js');

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

var _tracker = require('../../assets/js/tracker.js');

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        resultAreaReady: { type: Boolean, default: false }
    },
    components: {
        autosuggestion: _autosuggestion2.default,
        inputfield: _inputField2.default,
        datepicker: _datepicker2.default,
        dropdown: _dropDown2.default,
        btn: _button2.default,
        imageshifter: _imageshifter2.default
    },
    methods: {
        updateCarType: function updateCarType(val) {
            _tracker2.default.trackEvent('InputField', 'SelectedCarType', 'CarType', val);
            this.carTypeValue = val;
        },
        updateDays: function updateDays(val) {
            _tracker2.default.trackEvent('InputField', 'SelectedDays', 'Days', val);
            this.daysPerWeekValue = val;
        },
        updateFromInput: function updateFromInput(value, callback) {
            var self = this;
            this.addressFromLoading = true;
            this.getAddress(value, function (datalist) {
                self.addressFromLoading = false;
                self.dataListFrom = datalist;
                if (callback) {
                    callback();
                }
            });
        },
        updateToInput: function updateToInput(value, callback) {
            var self = this;
            this.addressToLoading = true;
            this.getAddress(value, function (datalist) {
                self.addressToLoading = false;
                self.dataListTo = datalist;
                if (callback) {
                    callback();
                }
            });
        },
        getAddress: function getAddress(value, callback) {
            if (this.working) {
                return;
            }

            this.$http.post(API_POINT + 'address?token=' + PENDLER_API_KEY, { 'address': value }).then(function (resp) {
                if (callback) {
                    callback(resp.data);
                }
            }, this.showError);
        },
        updateDate: function updateDate(val) {
            _tracker2.default.trackEvent('InputField', 'EnteredDate', 'Date', val);
            this.submitDate = (0, _moment2.default)(val).format("DDMMYYYY");
        },
        selectFromField: function selectFromField(val) {
            if (val !== this.fromInputValue) {
                _tracker2.default.trackEvent('InputField', 'EnteredFromField', 'FromField');
                this.fromInputValue = val;
            }
        },
        selectToField: function selectToField(val) {
            if (val !== this.toInputValue) {
                _tracker2.default.trackEvent('InputField', 'EnteredToField', 'ToField');
                this.toInputValue = val;
            }
        },
        updateTime: function updateTime(val) {
            _tracker2.default.trackEvent('InputField', 'EnteredTime', 'Time');
            this.selectedTime = val;
        },
        calculate: function calculate() {
            if (this.readyToCalc) {
                var input = {
                    'from_address': this.fromInputValue,
                    'to_address': this.toInputValue,
                    'arrival_date': this.submitDate,
                    'arrival_time': this.selectedTime.replace(/:/gi, ''),
                    'car_type': this.carTypeValue,
                    'days_per_week': this.daysPerWeekValue,
                    'language': LOCALE
                };

                this.working = true;
                var self = this;
                this.$root.$broadcast('showmsg', { messages: { 0: TRANSLATIONS["messages"]["calculating"] }, type: 'info' });
                _tracker2.default.trackEvent('InputArea', 'Calculate clicked', 'CalcBen', input);
                this.$http.post(API_POINT + 'calculate?token=' + PENDLER_API_KEY, input).then(function (resp) {
                    _tracker2.default.trackEvent('InputArea', 'Calculation returned');
                    self.working = false;
                    console.log(resp.data);
                    self.$root.$broadcast('calcresult', resp.data);
                    self.$root.$broadcast('calcinput', input);
                    self.$root.$broadcast('showmsg', { messages: { 0: TRANSLATIONS["messages"]["success"] }, type: 'success' });
                }, this.showError);
            }
        },
        showError: function showError(resp) {
            this.working = false;
            _tracker2.default.trackEvent('InputArea', 'Calculation error returned', resp.data);
            this.$root.$broadcast('calcresult', null);
            if (resp.status == 0 || resp.status >= 500) {
                this.$root.$broadcast('showmsg', { messages: { 0: TRANSLATIONS['errors']['general'] }, type: 'error' });
            } else {
                this.$root.$broadcast('showmsg', { messages: resp.data, type: 'error' });
            }
        }
    },
    computed: {
        readyToCalc: function readyToCalc() {
            var toInputValue = this.toInputValue;
            var fromInputValue = this.fromInputValue;
            var selectedTime = this.selectedTime;
            var selectedDate = this.submitDate;

            return toInputValue && fromInputValue && selectedTime.length > 0 && selectedDate.length > 0 && !this.working && this.resultAreaReady;
        },
        privacyTxt: function privacyTxt() {
            var link = '<a href=' + COOKIE_LINK + '>' + this.privacy_link + '</a>';
            return this.privacy_txt.replace(/{privacy_link\}/, link);
        }
    },
    events: {
        inputFocus: function inputFocus() {
            this.$broadcast('inputChanged');
        },
        'fonts-loaded': function fontsLoaded() {
            var font = new _fontfaceobserver2.default('atbmedium');
            var self = this;
            font.load(null, 30000).then(function () {
                self.fontLoaded = true;
            }, function () {
                console.log('Fonts not loaded!');
            });
        }
    },
    data: function data() {
        return {
            head: TRANSLATIONS["general"]["browser_title"],
            description: TRANSLATIONS["input-header"]["description"],
            privacy_txt: TRANSLATIONS["input-header"]["privacy-notice"],
            privacy_link: TRANSLATIONS["input-header"]["privacy-link-txt"],
            calcBtn: TRANSLATIONS["input-header"]["calc-btn"],
            fromInput: TRANSLATIONS["input-header"]["from-input"],
            toInput: TRANSLATIONS["input-header"]['to-input'],
            arrivalTimeInput: TRANSLATIONS["input-header"]['arrival-time-input'],
            dateInput: TRANSLATIONS["input-header"]['date-input'],
            carTypeInput: TRANSLATIONS["input-header"]["car-type-input"],
            daysWeekInput: TRANSLATIONS["input-header"]["days-week-input"],

            carPictures: {
                '1': BASE_URL + '/assets/img/car-mid.svg',
                '2': BASE_URL + '/assets/img/car-mid.svg',
                '3': BASE_URL + '/assets/img/car-high.svg',
                '4': BASE_URL + '/assets/img/car-high.svg',
                '5': BASE_URL + '/assets/img/car-hybrid.svg',
                '6': BASE_URL + '/assets/img/car-electric.svg'
            },

            dataListFrom: [],
            addressFromLoading: false,
            dataListTo: [],
            addressToLoading: false,
            carList: [],
            fromInputValue: null,
            toInputValue: null,

            daysPerWeek: TRANSLATIONS["input-header"]["days-week-options"],
            carTypeValue: 1,
            daysPerWeekValue: 5,
            selectedDate: (0, _moment2.default)().format("DD-MM-YYYY"),
            submitDate: (0, _moment2.default)().format("DDMMYYYY"),
            selectedTime: "08:00",

            working: false,
            fontLoaded: false,
            language: LOCALE,
            fromTo: INPUT_DATA
        };
    },
    ready: function ready() {
        var _this = this;

        if (this.fromTo && this.fromTo.t) {
            this.updateTime(this.fromTo.t);
        }

        if (this.fromTo && this.fromTo.d) {
            this.selectedDate = this.fromTo.d; // Set the selectedDate
            this.updateDate((0, _moment2.default)(this.fromTo.d, 'DD-MM-YYYY')); // Trigger date update, as if set by datepicker
        }

        if (this.fromTo.to) {
            this.updateToInput(this.fromTo.to, function () {
                _this.$nextTick(function () {
                    _this.$refs.toinput.selectItem(0);
                });
            });
        }

        if (this.fromTo.from) {
            this.updateFromInput(this.fromTo.from, function () {
                _this.$nextTick(function () {
                    _this.$refs.frominput.selectItem(0);
                });
            });
        }

        this.$http.get(API_POINT + 'car?token=' + PENDLER_API_KEY + '&language=' + LOCALE, function (resp) {
            if (resp) {
                this.carList = resp;
            }
        }, this.showError);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=input-wrapper v-bind:class=\"{'working': working}\"><div class=input-header><h1 class=input-header__heading :class=\"{'font-loaded': fontLoaded}\">{{ head }}</h1><p class=input-header__text>{{{ description }}}</div><div class=input-fields><div class=row-1><autosuggestion id=from_input v-ref:frominput=\"\" :text=fromInput :loading=addressFromLoading v-on:selectitem=selectFromField v-on:updateval=updateFromInput :data-list=dataListFrom tab-index=1 :list-filter=false filter-on-object=name></autosuggestion><autosuggestion id=to_input v-ref:toinput=\"\" :text=toInput :loading=addressToLoading v-on:selectitem=selectToField v-on:updateval=updateToInput :data-list=dataListTo tab-index=2 :list-filter=false filter-on-object=name></autosuggestion><div class=two-rows><inputfield id=time_input input-type=tel v-on:update=updateTime :inpvalue=selectedTime :text=arrivalTimeInput tab-index=3 v-ui-mask=\"\" format=99:99 maxlength=5></inputfield><datepicker id=date_input :text=dateInput tab-index=4 v-on:pickdate=updateDate :value=selectedDate format=DD-MM-YYYY></datepicker></div></div><div class=row-2><dropdown id=car_type_input :label=carTypeInput name=carTypeInput tab-index=5 :list=carList :selected-val=carTypeValue v-on:update=updateCarType></dropdown><dropdown id=days_week_input :label=daysWeekInput name=daysWeekInput tab-index=6 :list=daysPerWeek :selected-val=daysPerWeekValue v-on:update=updateDays></dropdown><p class=privacy-notice>{{{ privacyTxt }}}</div></div><div class=calc-block><btn id-tag=btn_calculation :disabled=!readyToCalc tab-index=7 :text=calcBtn @click=calculate></btn></div><div class=illustration-block><div class=illustration-block__car><imageshifter class=illustration-car :value=carTypeValue :pic-list=carPictures></imageshifter><img class=illustration-bike src=/assets/img/bike-blue.svg alt=\"\"></div><div class=illustration-block__transport><img src=/assets/img/sydtrafik-public-transport.svg alt=\"\"></div></div></div>"
